import Entity from './entity'

export default class SaleOrder extends Entity<number>{
    code: string;
    soDate: Date;
    expectedDeliveryDate: Date;
    promisedDeliveryDate: Date;
    cutOffTime: Date;
    startedPickingDate: Date;
    endedPickingDate: Date;
    startedPackingDate: Date;
    endedPackingDate: Date;
    handOnDate: Date;
    actualDeliveryDate: Date;
    returnedDate: Date;
    canceledDate: Date;
    canceledBy: number;
    customerName: string;
    customerPhone: string;
    shippingAddressNo: string;
    shippingFullAddress: string;
    clientCode: string;
    warehouseCode: string;
    soStatusCode: string;
    inputChannelCode: string;
    bizType: string;
    externalCode: string;
    shippingServiceCode: string;
    tplCode: string;
    srcClientBranchId: number;
    dstClientBranchId: number;
    maxProductSizeCode: string;
    totalWeight: number;
    totalVolume: number;
    parentId: number;
    numOfPackage: number;
    isClientPickup: boolean;
    isNoPack: boolean;
    isLabelling: boolean;
    isShippable: boolean;
    outboundMode: string;
    problemNote: string;
    packingNote: string;
    canceledNote: string;
    shippingNote: string;
    creationTime: Date;
    creatorUserId: number;
    creatorUserName: string;
    statusName:string;
    clientName:string;
    warehouseName:string;
    cod:number;
    shippingFee:number;
    pickListCode: string;
    aoGroupCode :string;
    toReqId:number;
    packageQty :number;
    packageRTShipQty:number;
    packageShippedQty:number;
    shippingDistrictId: number | null;
    shippingWardId: number | null;
    soRequestId : number;
    soRequestCode:string;
}
